export const signIn = authInfo => ({
  type: 'SIGN_IN',
  payload: authInfo
});

export const watchState = () => ({
  type: 'WATCH_AUTH_STATE'
});

export const setSignInLoading = isLoading => ({
  type: 'SET_SIGN_IN_LOADING',
  payload: isLoading
});

export const signInSuccess = user => ({
  type: 'SIGN_IN_SUCCESS',
  payload: user
});

export const signInFailure = error => ({
  type: 'SIGN_IN_FAILURE',
  payload: error
});

export const signOutRequest = () => ({
  type: 'SIGN_OUT_REQUEST'
});

export const signOutSuccess = () => ({
  type: 'SIGN_OUT_SUCCESS'
});

export const signOutFailure = () => ({
  type: 'SIGN_OUT_FAILURE'
});

export const fetchDataRequest = () => ({
  type: 'FETCH_DATA_REQUEST'
});

export const refreshUserInfoRequest = () => ({
  type: 'REFRESH_USER_INFO_REQUEST'
});

export const fetchDataSuccess = data => ({
  type: 'FETCH_DATA_SUCCESS',
  payload: data
});

export const fetchDataFailure = error => ({
  type: 'FETCH_DATA_FAILURE',
  payload: error
});
